import { buildPlanningDayCell } from './equipePlanningUtils';
import { getParisWeekDays } from './equipeWeekParis';
import { parisYmd } from './planningDayParis';

function todayParisDay() {
  const ymd = parisYmd();
  const week = getParisWeekDays(0);
  return week.find((d) => d.ymd === ymd) || week[0];
}

/**
 * Statut opérationnel du jour pour un membre (présence / absence / disponibilité).
 * @returns {{ key: string, label: string, tone: string }}
 */
export function getMemberTodayPresence(
  member,
  horairesConfig,
  absences = [],
  dateExceptionsByDate = null,
  reference = new Date(),
) {
  if (member?.actif === false) {
    return { key: 'inactive', label: 'Inactif', tone: 'rose' };
  }
  if (!member?.isIntervenant || !member?.instructeurId) {
    return { key: 'team', label: 'Membre équipe', tone: 'slate' };
  }

  const day = todayParisDay();
  const cell = buildPlanningDayCell(
    horairesConfig,
    absences,
    day.jourSemaine,
    day.ymd,
    dateExceptionsByDate,
  );

  if (cell.type === 'absence') {
    return { key: 'absent', label: 'Absent', tone: 'gray' };
  }
  if (cell.type === 'partial') {
    return { key: 'partial', label: 'Indisponible partiel', tone: 'amber' };
  }
  if (cell.type === 'full' || cell.type === 'split' || cell.type === 'exception') {
    return { key: 'present', label: 'Présent', tone: 'emerald' };
  }
  return { key: 'off', label: 'Hors plage', tone: 'gray' };
}

/** KPI « Membres actifs » = toute personne équipe avec actif !== false (API Mon équipe), pas seulement les professionnels prestataires. */
export function computePresencesKpis(
  members,
  horairesByInstructeur,
  absencesByInstructeur,
  dateExceptionsByInstructeur = {},
) {
  const list = members || [];
  const actifs = list.filter((m) => m.actif !== false);
  let presents = 0;
  let absents = 0;
  let indisponibles = 0;

  for (const m of actifs) {
    if (!m.isIntervenant || !m.instructeurId) continue;
    const config = horairesByInstructeur[m.instructeurId];
    const absences = absencesByInstructeur[m.instructeurId] || [];
    const dateExceptions = dateExceptionsByInstructeur[m.instructeurId] || null;
    const status = getMemberTodayPresence(m, config, absences, dateExceptions);
    if (status.key === 'present') presents += 1;
    else if (status.key === 'absent') absents += 1;
    else if (status.key === 'partial' || status.key === 'off') indisponibles += 1;
  }

  return {
    actifs: actifs.length,
    presents,
    absents,
    indisponibles,
  };
}
